interface Props {
  eyebrow?: string
  title: string
  intro?: string
  align?: 'left' | 'center'
  noBorder?: boolean
}

function PageHero({ eyebrow, title, intro, align = 'left', noBorder = false }: Props) {
  const isCenter = align === 'center'
  return (
    <section className={`relative pt-40 md:pt-48 pb-20 md:pb-28 px-6 md:px-10${noBorder ? '' : ' border-b border-[#DCC9D2]/70'}`}>
      <div className={`max-w-6xl mx-auto ${isCenter ? 'text-center' : ''}`}>
        {eyebrow && (
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#C0923F] mb-8 animate-fade-in">
            {eyebrow}
          </div>
        )}
        <h1 className="font-serif-display text-[36px] md:text-[60px] leading-[1.05] text-[#1F1B1D] animate-fade-up max-w-4xl">
          {title}
        </h1>
        {intro && (
          <p className={`mt-8 font-serif-display italic text-[18px] md:text-[20px] leading-[1.55] text-[#3A3236] max-w-2xl animate-fade-up delay-200 ${isCenter ? 'mx-auto' : ''}`}>
            {intro}
          </p>
        )}
      </div>
    </section>
  )
}

export default PageHero
